module.exports = __webpack_public_path__ + "img/wine_full.e3d651ec.png";